import {
  browserTracingIntegration,
  replayIntegration,
  init,
} from "@sentry/react";

const SENTRY_DSN: string | null = import.meta.env.VITE_SENTRY_DSN || null;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;
const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE || undefined;

const TRACE_PROPAGATION_TARGETS = import.meta.env.VITE_API_URL
  ? [import.meta.env.VITE_API_URL, "localhost"]
  : ["localhost"];
export const initSentry = () => {
  // Only initialize Sentry if DSN is provided
  if (!SENTRY_DSN || SENTRY_DSN.trim() === "") {
    console.log("Sentry DSN not provided, skipping Sentry initialization");
    return;
  }

  init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    sendDefaultPii: true,
    integrations: [
      browserTracingIntegration(),
      ...(import.meta.env.PROD ? [replayIntegration()] : []),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
  });
};
